<!-- Menu Toggle Button -->
<a href="#" class="nav-link user-trigger" data-toggle="dropdown" role="button">
  <span class="user-avatar">
    <img *ngIf="hasAvatar" [src]="currentUser.avatarUrl" [alt]="currentUser.getName()" (error)="avatarFailed = true">
    <ng-container *ngIf="!hasAvatar">{{initial}}</ng-container>
  </span>
  <span class="user-greeting hidden-xs">{{ hello }}, <strong>{{currentUser.getName()}}</strong><ng-container *ngIf="companyName"> - {{companyName}}</ng-container></span>
</a>
<!-- Menu do usuário (padrão Taxfy): identificação, empresa ativa e ações -->
<div class="dropdown-menu dropdown-menu-right user-dropdown">
  <div class="user-dropdown__header">
    <span class="user-dropdown__name">{{currentUser.getName()}}</span>
    <span class="user-dropdown__email" *ngIf="currentUser.email">{{currentUser.email}}</span>
  </div>

  <div class="user-dropdown__section" *ngIf="companyName; else elseBlock">
    <span class="user-dropdown__label">{{ selectedCompany }}</span>
    <span class="user-dropdown__company">{{ companyName }}</span>
    <span class="user-dropdown__id" *ngIf="companyId">
      ID <code>{{ companyId }}</code>
      <button type="button" class="user-dropdown__copy" title="Copiar ID" (click)="copyCompanyId($event)">
        <i class="far fa-copy"></i>
      </button>
    </span>
    <span class="user-dropdown__role" *ngIf="roleName">Perfil: <strong>{{ roleName }}</strong></span>
  </div>
  <ng-template #elseBlock>
    <div class="user-dropdown__section user-dropdown__empty">{{ noCompanySelected }}</div>
  </ng-template>

  <ng-container *ngIf="showChangeCompany">
    <a class="dropdown-item" (click)="change()">
      <i class="fas fa-exchange-alt"></i>
      <span>{{ chooseCompany }}</span>
    </a>
    <div class="dropdown-divider"></div>
  </ng-container>

  <ng-container *ngIf="adminItems.length">
    <span class="user-dropdown__label user-dropdown__group">{{ 'SHARED.settings' | translate }}</span>
    <a *ngFor="let item of adminItems" class="dropdown-item" [routerLink]="item.route">
      <i [class]="item.icon"></i>
      <span>{{ item.labelKey | translate }}</span>
    </a>
    <div class="dropdown-divider"></div>
  </ng-container>

  <a class="dropdown-item" (click)="logout()">
    <i class="fas fa-sign-out-alt"></i>
    <span>{{ signOut }}</span>
  </a>
</div>
